import { useSplitEnabled } from '@buffer-mono/features'

import { useAccount } from '~publish/contexts/AccountContext'

export const useShouldShowDeveloperData = (): boolean => {
  const { isEnabled } = useSplitEnabled('cx-show-app-data')
  const { account } = useAccount()

  return isEnabled || account?.isImpersonation === true
}
